module.exports = __webpack_public_path__ + "static/img/ico5.1f19822.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/homepage/img/widget/ico5.png
// module id = nnCX
// module chunks = 11